import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TextAreaField from '../../FormsElements/TextAreaField';
import { handleSave } from '../../MitigationTable';
import EventButton from '../../Buttons/EventButton';

function SafetyRequirements({ srm, editItem }) {
  console.log('SrmPre', srm);
  const [formData, setFormData] = useState({
    mitigation: '',
    typeOfControl: 0,
    priority: 0,
    deadline: new Date().toISOString(),
    implementor: '',
    incidentId: 0,
    safetyId: 0,
  });

  useEffect(() => {
    setFormData({
      mitigation: editItem ? editItem.safetyRequirement : '',
      typeOfControl: editItem ? editItem.typeOfControl : 0,
      priority: editItem ? editItem.priority : 0,
      safetyId: editItem ? editItem.safetyId : 0,
      deadline: editItem ? editItem.deadline : new Date().toISOString(),
      implementor: editItem ? editItem.actionBy : '',
      incidentId: srm ? srm.id : 0,

    });
  }, [editItem, srm]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    console.log('formData', formData);
    console.log('Id', typeof formData.incidentId);
    if (editItem) {
      const method = 'PATCH';
      await handleSave(`occurrences-data/${formData.safetyId}/update-safety-requirements`, formData, method);
    } else {
      const method = 'POST';
      await handleSave(`occurrences-data/add-safety-requirements/${formData.incidentId}`, formData, method);
    }
  };

  return (
    <div className="relative p-4 w-full max-w-2xl max-h-full">
      <TextAreaField
        label="Safety Requirement"
        name="mitigation"
        value={formData.mitigation}
        onChange={handleChange}
        type="text"
        row={1}
        col={10}
      />
      <TextAreaField
        label="Type Of Control"
        name="typeOfControl"
        value={formData.typeOfControl}
        onChange={handleChange}
        type="text"
        row={1}
        col={10}
      />
      <TextAreaField
        label="Priority"
        name="priority"
        value={formData.priority}
        onChange={handleChange}
        type="text"
        row={1}
        col={10}
      />
      <TextAreaField
        label="Deadline"
        name="deadline"
        value={formData.deadline}
        onChange={handleChange}
        type="date"
        row={1}
        col={10}
      />
      <TextAreaField
        label="Implementor"
        name="implementor"
        value={formData.implementor}
        onChange={handleChange}
        type="text"
        row={1}
        col={10}
      />
      {/* {!editItem && (
      <TextAreaField
        label="Reported By"
        name="reportedBy"
        value={formData.actionReportedBy}
        onChange={handleChange}
        type="text"
        row={1}
        col={10}
      />
      )} */}
      <EventButton
        onSubmit={handleSubmit}
        linktext={editItem ? 'Edit' : 'Add'}
      />
    </div>
  );
}

SafetyRequirements.propTypes = {
  editItem: PropTypes.shape({
    safetyRequirement: PropTypes.string,
    typeOfControl: PropTypes.number,
    priority: PropTypes.number,
    safetyId: PropTypes.number,
    deadline: PropTypes.string,
    actionBy: PropTypes.string,

  }),
  // eslint-disable-next-line react/forbid-prop-types
  srm: PropTypes.object.isRequired,
};

SafetyRequirements.defaultProps = {
  editItem: null,
  // srm: null,
};

export default SafetyRequirements;
